<template>
  <v-container fluid class="asor-rbu-detail" v-if="a_sor">
    <v-row class="flex-grow-0">
      <v-btn
        text
        color="primary"
        x-small
        exact
        :to="{
          name: 'a-sor-detail',
          params: {
            aSorId: a_sor.id,
          },
        }"
      >
        &lt;&lt; A_SoR: {{ a_sor.name }}
      </v-btn>
    </v-row>

    <v-row class="rbu-section-info-wrapper">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        class="ml-4 mt-2"
        small
        @click="showCreateItemDialog"
      >
        Add RBU Item
      </v-btn>
      <v-btn color="primary" class="ml-4 mt-2" small @click="goToRbuConfig">
        RBU Configuration
      </v-btn>
    </v-row>
    <v-row class="flex-grow-1 rounded-b">
      <v-tabs
        v-model="tab"
        align-tabs="center"
        bg-color="transparent"
        style="margin-top: 1rem; width: fit-content"
        background-color="transparent"
        @change="(num) => onChangeTab(num)"
      >
        <v-tab :value="'tab-1'">SoR items mapping</v-tab>
        <v-tab-item style="height: 75vh">
          <ASorItemMappingList
            full-height
            style=""
            :extra-filters="{
              ['a_sor']: [$route.params.aSorId],
            }"
            :refresh-trigger="refreshMappingTrigger"
            :a_sor="a_sor"
            @update:refresh-trigger="refresh"
          ></ASorItemMappingList>
        </v-tab-item>
        <v-tab :value="'tab-2'">SoR items status summary</v-tab>
        <v-tab-item style="height: 75vh">
          <ASorItemList
            full-height
            style=""
            :extra-filters="{
              ['asor']: [$route.params.aSorId],
            }"
            :a_sor="a_sor"
            :refresh-mapping-trigger="refreshMappingTrigger"
            @update:refresh-mapping-trigger="refresh"
          ></ASorItemList>
        </v-tab-item>
      </v-tabs>
    </v-row>

    <v-row></v-row>
  </v-container>
</template>
<script>
import { ACTION_TYPES } from "@/store/types";
import { computed, onMounted, ref } from "@vue/composition-api";
import ASorItemList from "@/components/asor/ASorItemList.vue";
import ASorItemMappingList from "@/components/asor/ASorItemMappingList.vue";
import NewASorRbuItemDialog from "@/components/asor/NewASorRbuItemDialog.vue";

export default {
  name: "AsorRbu",
  components: { ASorItemList, ASorItemMappingList },
  setup(props, { root }) {
    const a_sor = ref(null);
    const refreshMappingTrigger = ref(false);
    const getAsor = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/contract/a_sor/",
        params: { a_sor_id: root.$route.params.aSorId },
      });

      if (response.body.success) {
        a_sor.value = response.body.a_sor;
      }
    };

    const tab = computed({
      get() {
        return root.$store.state.rbuSectionItemList.tab;
      },
      set(tab) {
        updateTab(tab);
      },
    });

    const onChangeTab = (num) => {
      console.log(num);
      if (num === 0) {
        refresh();
      } else {
      }
    };

    const goToRbuConfig = async function () {
      root.$router.push({
        name: "a-sor-rbu-config",
      });
    };

    const updateTab = async function (tab) {
      await root.$store.dispatch(ACTION_TYPES.RBU_UPDATE_ITEM_LIST_TAB, tab);
    };

    const refresh = async (target = true) => {
      refreshMappingTrigger.value = target;
    };

    const showCreateItemDialog = async () => {
      const new_item_id = await root.$dialog.showAndWait(NewASorRbuItemDialog, {
        showClose: false,
        persistent: true,
        a_sor_id: a_sor.value.id,
      });

      if (new_item_id) {
        root.$router.push({
          name: "a-sor-rbu-item-detail",
          params: { rbuItemId: new_item_id },
        });
      }
    };

    onMounted(() => {
      getAsor();
    });

    return {
      a_sor,
      tab,
      refreshMappingTrigger,
      refresh,
      getAsor,
      goToRbuConfig,
      showCreateItemDialog,
      onChangeTab,
    };
  },
};
</script>

<style lang="less">
.asor-rbu-detail {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .rbu-section-info-wrapper {
    flex: 0 0 auto;
    display: flex;

    .rbu-section-info {
      flex: 1 1 0;
    }
  }
}

.theme--dark.v-tabs-items {
  background-color: transparent !important;
}

.theme--light.v-tabs-items {
  background-color: transparent !important;
}
</style>
